import React from 'react';
import { Box, Typography, Button, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Container from 'common/components/Container';
import { push, Routes } from 'routing';
import { useTranslation } from 'services/localization';

import emptyInventoryLogo from 'common/assets/inventory-empty@2x.png';

interface Props {
	skipOnboarding: () => void;
}

const InventoryOnboarding = (props: Props) => {
	const { t } = useTranslation();
	const classes = useStyles();
	return (
		<>
			<Container>
				<Box
					display="flex"
					justifyContent="center"
					alignItems="center"
					flexDirection="column"
					textAlign="center"
				>
					<Box mt={4}>
						<img src={emptyInventoryLogo} alt="Empty inventory" className={classes.emptyLogo} />
					</Box>
					<Box mt={8}>
						<Typography variant="h5">
							{t('inventory.onBoarding.title', `Let's build your inventory`)}
						</Typography>
					</Box>
					<Box mt={2}>
						<Typography variant="body1">
							{t(
								'inventory.onBoarding.body1',
								`We'll guide you in setting up your first inventory articles, SKUs, and everyting else that's needed at this point.`,
							)}
						</Typography>
						<Typography variant="body1">
							{t('inventory.onBoarding.body2', `Add your first inventory articles to get started.`)}
						</Typography>
					</Box>
					<Box mt={8}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => push(Routes.INVENTORY_ARTICLES_ADD)}
						>
							{t('inventory.onBoarding.continueBtn', `Get started`)}
						</Button>
					</Box>
					<Box mt={2}>
						<Button variant="text" color="secondary" onClick={props.skipOnboarding}>
							{t('inventory.onBoarding.skipBtn', `Skip guide`)}
						</Button>
					</Box>
				</Box>
			</Container>
		</>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		emptyLogo: {
			maxWidth: 230,
		},
	}),
);

export default InventoryOnboarding;
